import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=5b12bc58&"
import script from "./Make.vue?vue&type=script&lang=js&"
export * from "./Make.vue?vue&type=script&lang=js&"
import style0 from "./Make.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports